module.exports = __webpack_public_path__ + "img/ba-area.8629f680.jpg";